"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VictoryOverlay = VictoryOverlay;
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const ui_1 = require("@creature-chess/ui");
const players_1 = require("~/store/game/players");
const useStyles_1 = require("~/useStyles");
const boardOverlay_1 = require("./boardOverlay");
const useStyles = (0, useStyles_1.createUseThemeStyles)((theme) => ({
    root: {
        "display": "flex",
        "flexDirection": "column",
        "justifyContent": "center",
        "width": "100%",
        "gap": "16px",
        "@media (orientation: portrait) and (min-width: 431px)": {
            gap: "32px",
        },
    },
    wrapper: {
        textAlign: "center",
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        background: "#566c86",
        border: "2px solid #b13e53",
        fontFamily: theme.typography.primary,
    },
    title: {
        "textAlign": "left",
        "padding": "4px 8px",
        "fontFamily": theme.typography.accent,
        "fontSize": "36px",
        "borderBottom": "2px solid #b13e53",
        "@media (orientation: portrait) and (max-width: 430px)": {
            fontSize: "24px",
        },
    },
    outcomes: {
        background: "#30364b",
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },
    links: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
    },
    winner: {
        "flex": 2,
        "display": "flex",
        "flexDirection": "column",
        "justifyContent": "center",
        "fontSize": "24px",
        "@media (orientation: portrait) and (min-width: 431px)": {
            fontSize: "32px",
        },
    },
    mainMenu: {
        margin: "0 auto",
        flex: 1,
    },
    discordButton: {
        flex: 1,
    },
    discordIcon: {
        height: "32px",
    },
}));
function VictoryOverlay() {
    const styles = useStyles();
    const winnerId = (0, react_redux_1.useSelector)((state) => state.game.ui.winnerId);
    const winner = (0, players_1.useGamePlayer)(winnerId);
    const onMenuClick = () => (window.location.href = APP_URL);
    if (!winner) {
        return null;
    }
    const winnerName = winner.name;
    return (React.createElement(boardOverlay_1.BoardOverlay, null,
        React.createElement("div", { className: styles.root },
            React.createElement("div", { className: styles.wrapper },
                React.createElement("div", { className: styles.title }, "Game Over!"),
                React.createElement("div", { className: styles.outcomes },
                    React.createElement("div", { className: styles.winner },
                        winnerName,
                        " wins!"),
                    React.createElement("div", { className: styles.links },
                        React.createElement("a", { href: "https://discord.gg/FhMm6saehb", className: styles.discordButton },
                            React.createElement("img", { src: "/images/ui/discord.png", className: styles.discordIcon })),
                        React.createElement("div", { className: styles.mainMenu },
                            React.createElement(ui_1.Button, { color: "primary", size: "medium", onClick: onMenuClick }, "Main Menu"))))))));
}
